import React, { useEffect, useRef, useState } from "react";
import { Link } from "react-router-dom";
import { all_routes } from "../../../router/all_routes";
import ImageWithBasePath from "../../../../core/common/imageWithBasePath";
import Table from "../../../../core/common/dataTable/index";
import {
  gender,
  SORT_OPTIONS,
  status,
} from "../../../../core/common/selectoption/selectoption";
import CommonSelect, { Option } from "../../../../core/common/commonSelect";
import TooltipOption from "../../../../core/common/tooltipOption";
import { getAdmissions } from "../../../../service/admission";
import { formatDate, formatDateTime } from "../../../../utils/dateutils";
import AdmissionModals from "../admissionModals";
import { selectCurrentSession } from "../../../../core/data/redux/slice/sessionsSlice";
import { useSelector } from "react-redux";
import { useReactToPrint } from "react-to-print";
import * as XLSX from "xlsx";
import { Class, getAllClasses } from "../../../../service/classes";
import { selectSystemsForCurrentBranch } from "../../../../core/data/redux/slice/systemsSlice";
import AdmissionLetter from "../admission-letter";
import { selectUser } from "../../../../core/data/redux/slice/user";
import MultiSelectSection from "../../../../core/common/multiSelect";
import { selectBranches, selectCurrentBranch } from "../../../../core/data/redux/slice/branchesSlice";
import { campusBrandName, campusBranchLabel, isAdmissionLetterHiddenCampus } from "../../../../utils/campusLogos";
export interface FeeRecord {
  _id: string;
  discount: number;
  status: string;
  invoiceNumber: string;
  total: number;
  subTotal: number;
  paymentType: string;
  dueDate: string | null;
  branch: string;
  session: string;
  system: string;
  class: string;
  isDeleted: boolean;
  createdAt: string;
  updatedAt: string;
  __v: number;
  enrollment: string;
  student: {
    grNumber: string;
  };
  admission: {
    appliedClass: {
      name: string;
    };
    _id: string;
    firstName: string;
    lastName: string;
    dateOfBirth: string;
    gender: string;
    bloodGroup: string;
    religion: string;
    email: string;
    motherTongue: string;
    languageKnown: string[];
    hasMedicalIssue: boolean;
    nationality: string;
    bFormNo: string;
    placeOfBirth: string;
    mobileNO: string;
    hasSiblings: boolean;
    noOfSiblings: number;
    isVaccinated: boolean;
    fatherName: string;
    fatherCnic: string;
    fatherEmail: string;
    isFatherVaccinated: boolean;
    isMotherVaccinated: boolean;
    isGuardianVaccinated: boolean;
    city: string;
    area: string;
    houseNo: string;
    system: string;
    prevSchoolName: string;
    prevSchoolAddress: string;
    prevClass: string;
    lastResult: string;
    transferCertificate: string;
    birthCertificate: string;
    section: {
      name: string;
      _id: string;
    };
    status: string;
    branch: string;
    session: string;
    isDeleted: boolean;
    createdAt: string;
    updatedAt: string;
    __v: number;
    invoice: string;
    studentPicture: string;
    temporaryGR: string;
  };
  notes: string;
  invoiceItems: Array<{
    _id: string;
    feeType: { name: string };
    feeGroup: { name: string };
    amount: number;
    discount: number;
    description: string;
    createdAt: string;
    updatedAt: string;
    __v: number;
    invoice: string;
    month: string;
  }>;
}

export interface AdmissionData {
  _id: string;
  registrationNumber: string;
  firstName: string;
  lastName: string;
  gender: string;
  status: string;
  enrollment: string;
  createdAt: string;
  dateOfBirth: string;
  fatherEmail: string;
  fatherPhoneNumber: string;
  fatherName: string;
  studentPicture: string;
  temporaryGR: string;
  grNumber?: string;
  feeGroups: Array<{
    _id: string;
    name: string;
  }>;
  feeTypes: Array<{
    _id: string;
    name: string;
    amount: number;
  }>;
  appliedClass: {
    name: string;
    _id?: string;
  };
  section: {
    name: string;
    _id: string;
  };
  // The aggregation's $lookup on admission.js's list route joins these as
  // full documents (not just the name the rest of this interface exposes),
  // so _id is really there on the payload -- needed to look up the applied
  // class's Tuition Fee FeeType for the Eon admission letter.
  session?: {
    _id: string;
    name?: string;
  };
  system?: {
    _id: string;
    name?: string;
  };
  invoice?: {
    _id: string;
    discount: {
      profile: number;
      manual: number;
    };
    status: string;
    invoiceNumber: string;
    total: number;
    subTotal: number;
    paymentType: string;
    dueDate: string | null;
    invoiceItems: Array<{
      _id: string;
      feeType: { name: string };
      feeGroup: { name: string };
      amount: number;
      description: string;
    }>;
    notes?: string;
  };
  // The admission's OWN campus — preferred over whatever's globally
  // selected in the header on letters/receipts printed for this record.
  branch?: string;
}

export interface paginationDataType {
  currentPage: number;
  hasNextPage: boolean;
  hasPrevPage: boolean;
  limit: number;
  total: number;
  totalPages: number;
}

const AdmissionList = () => {
  const currentSession = useSelector(selectCurrentSession);
  const currentBranch = useSelector(selectCurrentBranch);
  const branches = useSelector(selectBranches);
  const systems = useSelector(selectSystemsForCurrentBranch);
  const routes = all_routes;
  const componentRef = useRef<HTMLDivElement>(null);
  const dropdownMenuRef = useRef<HTMLDivElement | null>(null);
  const [data, setData] = useState<AdmissionData[]>([]);
  const [loading, setLoading] = useState(true);
  const [searchText, setSearchText] = useState("");
  const [classes, setAllClasses] = useState<Option[]>([]);
  const user = useSelector(selectUser);
  const [classesLoading, setClassesLoading] = useState(false);
  const [paginationData, setPaginationData] = useState<paginationDataType>();
  const [pagination, setPagination] = useState({ limit: 10, page: 1 });
  const [selectedId, setSelectedId] = useState<string | null>(null);
  const [showAdmissionLetter, setShowAdmissionLetter] = useState(false);
  const [selectedAdmissionForLetter, setSelectedAdmissionForLetter] =
    useState<AdmissionData | null>(null);
  const [selectedAdmission, setSelectedAdmission] =
    useState<AdmissionData | null>(null);
  const [filters, setFilters] = useState<{
    class?: Option[];
    gender?: Option;
    status?: Option;
  } | null>(null);

  const [appliedFilters, setAppliedFilters] = useState<{
    class?: string[];
    gender?: string;
    status?: string;
    startDate?: string;
    endDate?: string;
    system?: string;
  } | null>({ system: systems[0]?._id });

  const [sortBy, setSortBy] = useState(SORT_OPTIONS[0]);

  const fetchAdmissions = async () => {
    setLoading(true);
    try {
      const response = await getAdmissions({
        ...pagination,
        sessionId: currentSession?._id,
        ...appliedFilters,
         class: appliedFilters?.class?.join(','),
        ...sortBy.value,
        searchText,
      });
      setData(response.data);
      setPaginationData(response.pagination);
    } catch (error) {
      console.error("Failed to fetch admissions:", error);
    } finally {
      setLoading(false);
    }
  };

  const fetchClasses = async () => {
    setClassesLoading(true);
    try {
      const response = await getAllClasses();
      const formattedClasses = response.classes.map((classItem: Class) => ({
        label: classItem.name,
        value: classItem._id,
      }));
      setAllClasses(formattedClasses);
    } catch (error) {
      console.error("Error fetching classes:", error);
    } finally {
      setClassesLoading(false);
    }
  };

  useEffect(() => {
    fetchAdmissions();
  }, [pagination, currentSession?._id, appliedFilters, sortBy, searchText]);

  useEffect(() => {
    fetchClasses();
  }, []);

  const handleApplyClick = () => {
    if (dropdownMenuRef.current) {
      dropdownMenuRef.current.classList.remove("show");
    }
    const classIds = filters?.class?.map((cls) => cls.value) || [];
    setAppliedFilters({
      class: classIds,
      gender: filters?.gender?.value as string,
      status: filters?.status?.value as string,
    });
  };

  const handleChange = (page: number, pageSize: number) => {
    setPagination({ limit: pageSize, page: page });
  };

  const handlePrint = useReactToPrint({ contentRef: componentRef });

  const handleExportExcel = () => {
    const ws = XLSX.utils.json_to_sheet(
      data.map((item) => ({
        Name: item.firstName,
        "Father Name": item.fatherName,
        Classes: item.appliedClass.name,
        Section: item.section.name,
        Gender: item.gender,
        Status: item.status,
      }))
    );
    const wb = XLSX.utils.book_new();
    XLSX.utils.book_append_sheet(wb, ws, "Admissions");
    XLSX.writeFile(wb, "admissions.xlsx");
  };

  const handleResetFilters = () => {
    setFilters({
      class:[],
      gender: {
        label: "Select",
        value: "",
      },
      status: {
        label: "Select",
        value: "",
      },
    });
    setAppliedFilters(null);
  };

  const handleSortSelect = (item: {
    label: string;
    value: {
      sortBy: string;
      sortOrder: string;
    };
  }) => {
    setSortBy(item);
  };

  const handlePrintAdmissionLetter = (admission: AdmissionData) => {
    setSelectedAdmissionForLetter(admission);
    setShowAdmissionLetter(true);
  };

  const columns = [
    {
      title: "GR Number",
      dataIndex: "grNumber",
      sorter: (a: AdmissionData, b: AdmissionData) =>
        (a.grNumber || "").localeCompare(b.grNumber || ""),
      render: (grNumber: string) => grNumber || "N/A",
    },
    {
      title: "Temp GR",
      dataIndex: "temporaryGR",
      sorter: (a: AdmissionData, b: AdmissionData) =>
        (a.temporaryGR || "").localeCompare(b.temporaryGR || ""),
      render: (temporaryGR: string) => temporaryGR || "N/A",
    },
    {
      title: "Name",
      dataIndex: "firstName",
      render: (text: string, record: AdmissionData) => (
        <div className="d-flex align-items-center">
          <Link
            to={routes.admissionFormDetail}
            className="avatar avatar-md"
            state={record}
          >
            <ImageWithBasePath
              src={"assets/img/students/student-01.jpg"}
              fullSrc={record.studentPicture}
              className="img-fluid rounded-circle"
              alt="img"
            />
          </Link>
          <div className="ms-2">
            <p className="text-dark mb-0">
              <Link to={routes.admissionFormDetail} state={record}>
                {`${record.firstName} ${record.lastName}`}
              </Link>
            </p>
          </div>
        </div>
      ),
      sorter: (a: AdmissionData, b: AdmissionData) =>
        a.firstName.length - b.firstName.length,
    },
    {
      title: "Father Name",
      dataIndex: "fatherName",
      render: (fatherName: string) => fatherName || "N/A",
      sorter: (a: AdmissionData, b: AdmissionData) =>
        (a.fatherName || "").localeCompare(b.fatherName || ""),
    },
    {
      title: "Class",
      dataIndex: ["appliedClass", "name"],
      sorter: (a: AdmissionData, b: AdmissionData) =>
        a.appliedClass.name.length - b.appliedClass.name.length,
    },
    {
      title: "Section",
      dataIndex: ["section", "name"],
      sorter: (a: AdmissionData, b: AdmissionData) =>
        a.section.name.length - b.section.name.length,
    },
    {
      title: "Gender",
      dataIndex: "gender",
      sorter: (a: AdmissionData, b: AdmissionData) =>
        a.gender.length - b.gender.length,
    },

    {
      title: "Status",
      dataIndex: "status",
      render: (text: string) => (
        <>
          {text?.toLowerCase() === "admitted" ? (
            <span className="badge badge-soft-success d-inline-flex align-items-center">
              <i className="ti ti-circle-filled fs-5 me-1"></i>
              {text}
            </span>
          ) : (
            <span className="badge badge-soft-danger d-inline-flex align-items-center">
              <i className="ti ti-circle-filled fs-5 me-1"></i>
              {text}
            </span>
          )}
        </>
      ),
      sorter: (a: AdmissionData, b: AdmissionData) =>
        a.status.length - b.status.length,
    },
    {
      title: "Process Starts At",
      dataIndex: "createdAt",
      sorter: (a: AdmissionData, b: AdmissionData) =>
        new Date(a.createdAt).getTime() - new Date(b.createdAt).getTime(),
      render: (createdAt: string) => formatDateTime(createdAt),
    },
    {
      title: "DOB",
      dataIndex: "dateOfBirth",
      sorter: (a: AdmissionData, b: AdmissionData) =>
        new Date(a.dateOfBirth).getTime() - new Date(b.dateOfBirth).getTime(),
      render: (dateOfBirth: string) => formatDate(dateOfBirth),
    },
    {
      title: "Action",
      dataIndex: "action",
      className: "no-print",
      render: (_: unknown, record: AdmissionData) => {
        const phoneNumber = record.fatherPhoneNumber || "";
        const email = record.fatherEmail || "";

        return (
          <div className="d-flex align-items-center">
            {/* Always render the phone/mail icons (greyed + disabled when there
                is no value) so every row's action buttons stay aligned. */}
            {phoneNumber ? (
              <Link
                to={`tel:${phoneNumber}`}
                className="btn btn-outline-light bg-white btn-icon d-flex align-items-center justify-content-center rounded-circle p-0 me-2"
              >
                <i className="ti ti-phone" />
              </Link>
            ) : (
              <span
                className="btn btn-outline-light bg-white btn-icon d-flex align-items-center justify-content-center rounded-circle p-0 me-2 disabled"
                style={{ opacity: 0.4, pointerEvents: "none" }}
                aria-disabled="true"
              >
                <i className="ti ti-phone" />
              </span>
            )}
            {email ? (
              <Link
                to={`mailto:${email}`}
                className="btn btn-outline-light bg-white btn-icon d-flex align-items-center justify-content-center rounded-circle p-0 me-3"
              >
                <i className="ti ti-mail" />
              </Link>
            ) : (
              <span
                className="btn btn-outline-light bg-white btn-icon d-flex align-items-center justify-content-center rounded-circle p-0 me-3 disabled"
                style={{ opacity: 0.4, pointerEvents: "none" }}
                aria-disabled="true"
              >
                <i className="ti ti-mail" />
              </span>
            )}
            <Link
              to="#"
              data-bs-toggle="modal"
              data-bs-target="#add_fees_collect"
              className="btn btn-primary btn-sm fw-semibold me-2"
              onClick={() => setSelectedAdmission(record)}
            >
              Fee Voucher
            </Link>
            {/* Add Print Admission Letter Button — hidden for campuses with
                no admission letter yet (5 & 6) */}
            {!isAdmissionLetterHiddenCampus(
              (branches.find((b) => b._id === record.branch) || currentBranch)
                ?.campusNo
            ) && (
              <button
                className="btn btn-info btn-sm fw-semibold me-2"
                onClick={() => handlePrintAdmissionLetter(record)}
              >
                <i className="ti ti-printer me-1"></i>
                Admission Letter
              </button>
            )}
            <div className="dropdown">
              <Link
                to="#"
                className="btn btn-white btn-icon btn-sm d-flex align-items-center justify-content-center rounded-circle p-0"
                data-bs-toggle="dropdown"
                aria-expanded="false"
              >
                <i className="ti ti-dots-vertical fs-14" />
              </Link>
              <ul className="dropdown-menu p-3 list-dropdown">
                <li>
                  <Link
                    className="dropdown-item rounded-1"
                    to={routes.admissionFormDetail}
                    state={record}
                  >
                    <i className="ti ti-menu me-2" />
                    View Form
                  </Link>
                </li>
                <li>
                  <Link
                    className={`dropdown-item rounded-1 ${
                      !user.permissions?.includes("admission.edit") &&
                      user.permissions?.length
                        ? "not-allowed"
                        : ""
                    }`}
                    to={
                      user.permissions?.includes("admission.edit") ||
                      !user.permissions?.length
                        ? routes.editAdmissionForm
                        : "#"
                    }
                    state={
                      user.permissions?.includes("admission.edit") ||
                      !user.permissions?.length
                        ? record
                        : null
                    }
                    onClick={(e) => {
                      if (
                        !user.permissions?.includes("admission.edit") &&
                        user.permissions?.length
                      ) {
                        e.preventDefault();
                      }
                    }}
                  >
                    <i className="ti ti-edit-circle me-2" />
                    Edit
                  </Link>
                </li>

                <li>
                  <Link
                    className={`dropdown-item rounded-1 ${
                      !user.permissions?.includes("admission.delete") &&
                      user.permissions?.length
                        ? "not-allowed"
                        : ""
                    }`}
                    to="#"
                    data-bs-toggle={
                      user.permissions?.includes("admission.delete") ||
                      !user.permissions?.length
                        ? "modal"
                        : ""
                    }
                    data-bs-target={
                      user.permissions?.includes("admission.delete") ||
                      !user.permissions?.length
                        ? "#delete-modal"
                        : ""
                    }
                    onClick={(e) => {
                      if (
                        !user.permissions?.includes("admission.delete") &&
                        user.permissions?.length
                      ) {
                        e.preventDefault();
                        return;
                      }
                      setSelectedId(record._id);
                    }}
                  >
                    <i className="ti ti-trash-x me-2" />
                    Delete
                  </Link>
                </li>
              </ul>
            </div>
          </div>
        );
      },
    },
  ];
  return (
    <>
      {/* Page Wrapper */}
      <div className="page-wrapper">
        <div className="content">
          {/* Page Header */}
          <div className="d-md-flex d-block align-items-center justify-content-between mb-3">
            <div className="my-auto mb-2">
              <h3 className="page-title mb-1">Admissions</h3>
              <nav>
                <ol className="breadcrumb mb-0">
                  <li className="breadcrumb-item">
                    <Link to={routes.adminDashboard}>Dashboard</Link>
                  </li>
                  <li className="breadcrumb-item">Admissions</li>
                  <li className="breadcrumb-item active" aria-current="page">
                    Admission Form List
                  </li>
                </ol>
              </nav>
            </div>
            <div className="d-flex my-xl-auto right-content align-items-center flex-wrap">
              <TooltipOption
                onRefresh={fetchAdmissions}
                onExportPdf={handlePrint}
                onExportExcel={handleExportExcel}
              />
              <div className="mb-2">
                <Link
                  to={routes.addAdmissionForm}
                  className="btn btn-primary d-flex align-items-center"
                >
                  <i className="ti ti-square-rounded-plus me-2" />
                  New Admission
                </Link>
              </div>
            </div>
          </div>
          {/* /Page Header */}
          {/* Students List */}
          <div className="card">
            <div className="card-header d-flex align-items-center justify-content-between flex-wrap pb-0">
              <h4 className="mb-3">Admission Forms</h4>
              <div className="d-flex align-items-center flex-wrap">
                <div className="mb-3 me-2">
                  <CommonSelect
                    className="select"
                    options={systems}
                    value={systems.find(
                      (item) => item._id === appliedFilters?.system
                    )}
                    getOptionValue={(item) => item._id}
                    getOptionLabel={(item) => item.name}
                    onChange={(systemItem) =>
                      setAppliedFilters((prev) => ({
                        ...prev,
                        system: systemItem?._id,
                      }))
                    }
                  />
                </div>
                <div className="dropdown mb-3 me-2">
                  <Link
                    to="#"
                    className="btn btn-outline-light bg-white dropdown-toggle"
                    data-bs-toggle="dropdown"
                    data-bs-auto-close="outside"
                  >
                    <i className="ti ti-filter me-2" />
                    Filter
                  </Link>
                  <div
                    className="dropdown-menu drop-width"
                    ref={dropdownMenuRef}
                  >
                    <form>
                      <div className="d-flex align-items-center border-bottom p-3">
                        <h4>Filter</h4>
                      </div>
                      <div className="p-3 pb-0 border-bottom">
                        <div className="row">
                          <div className="col-md-12">
                            <div className="mb-3">
                              <label className="form-label">Class</label>
                              {classesLoading ? (
                                <div> Loading classes... </div>
                              ) : (
                               <MultiSelectSection
                                  options={classes}
                                  value={filters?.class || []}
                                  onChange={(selectedOptions: Option[]) => {
                                    setFilters((prev) => ({
                                      ...prev,
                                      class: selectedOptions,
                                    }));
                                  }}
                                  placeholder="Select classes..."
                                />
                              )}
                            </div>
                          </div>
                          <div className="col-md-6">
                            <div className="mb-3">
                              <label className="form-label">Gender</label>
                              <CommonSelect
                                className="select"
                                options={gender}
                                value={filters?.gender}
                                onChange={(genderItem) =>
                                  setFilters((prev) => ({
                                    ...prev,
                                    gender: genderItem as Option,
                                  }))
                                }
                              />
                            </div>
                          </div>
                          <div className="col-md-6">
                            <div className="mb-3">
                              <label className="form-label">Fee Status</label>
                              <CommonSelect
                                className="select"
                                options={status}
                                value={filters?.status}
                                onChange={(statusItem) =>
                                  setFilters((prev) => ({
                                    ...prev,
                                    status: statusItem as Option,
                                  }))
                                }
                              />
                            </div>
                          </div>
                        </div>
                      </div>
                      <div className="p-3 d-flex align-items-center justify-content-end">
                        <Link
                          to="#"
                          className="btn btn-light me-3"
                          onClick={handleResetFilters}
                        >
                          Reset
                        </Link>
                        <div
                          className="btn btn-primary"
                          onClick={handleApplyClick}
                        >
                          Apply
                        </div>
                      </div>
                    </form>
                  </div>
                </div>
                <div className="d-flex align-items-center bg-white border rounded-2 p-1 mb-3 me-2">
                  <Link
                    to={routes.admissionFormList}
                    className="active btn btn-icon btn-sm me-1 primary-hover"
                  >
                    <i className="ti ti-list-tree" />
                  </Link>
                  <Link
                    to={routes.admissionFormGrid}
                    className="btn btn-icon btn-sm bg-light primary-hover"
                  >
                    <i className="ti ti-grid-dots" />
                  </Link>
                </div>
                <div className="dropdown mb-3">
                  <Link
                    to="#"
                    className="btn btn-outline-light bg-white dropdown-toggle"
                    data-bs-toggle="dropdown"
                  >
                    <i className="ti ti-sort-ascending-2 me-2" />
                    Sort by {sortBy.label}
                  </Link>
                  <ul className="dropdown-menu p-3">
                    {SORT_OPTIONS.map((item, index) => (
                      <li key={index}>
                        <div
                          className={`dropdown-item rounded-1 ${
                            item.label === sortBy.label ? "active" : ""
                          }`}
                          style={{ cursor: "pointer" }}
                          onClick={() => handleSortSelect(item)}
                        >
                          {item.label}
                        </div>
                      </li>
                    ))}
                  </ul>
                </div>
              </div>
            </div>
            <div
              className="card-body p-0 py-3 printable-content"
              ref={componentRef}
            >
              <div className="print-only-header">
                <div className="school-brand">
                  <img src={currentBranch?.blackLogoUrl || "/assets/img/icons/logo.png"} alt={campusBrandName(currentBranch)} />
                  <strong>{campusBrandName(currentBranch)}{campusBranchLabel(currentBranch) ? ` - ${campusBranchLabel(currentBranch)}` : ""}</strong>
                </div>
                <div className="report-title">Admission List</div>
                <div className="print-date">{new Date().toLocaleDateString("en-GB")}</div>
              </div>
              <Table
                setSearchText={setSearchText}
                dataSource={data}
                columns={columns}
                loading={loading}
                pagination={{ ...paginationData, onChange: handleChange }}
              />
            </div>
          </div>
          {/* /Students List */}
        </div>
      </div>

      {showAdmissionLetter && (
        <AdmissionLetter
          admissionData={selectedAdmissionForLetter}
          onClose={() => {
            setShowAdmissionLetter(false);
            setSelectedAdmissionForLetter(null);
          }}
        />
      )}

      {/* /Page Wrapper */}
      <AdmissionModals
        selectedId={selectedId}
        setSelectedId={setSelectedId}
        fetchData={fetchAdmissions}
        admissionData={selectedAdmission}
      />
    </>
  );
};

export default AdmissionList;
